import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AppState} from './app.state';

export const selectAppState = createFeatureSelector<AppState>('app')

export const selectWhitelabel = createSelector(
    selectAppState,
    (state: AppState) => state.whitelabelInfo
)

export const selectWhitelabelConfig = createSelector(
    selectAppState,
    (state: AppState) => state.whitelabelConfig
)

export const selectWhitelabelOverrides = createSelector(
    selectAppState,
    (state: AppState) => state.whitelabelOverrides
)

export const selectWhitelabelSource = createSelector(
    selectAppState,
    (state: AppState) => state.whitelabelSource
)
